const resizeDots = (event, slick, currentSlide) => { 
  let i;
  for (i = 0; i < slick.$dots[0].children.length; i++) {
    const dot = slick.$dots[0].children[i];
    let scale = 1 - Math.abs(i - (currentSlide || 0)) * 0.2;
    scale = Math.max(scale, 0.5);
    dot.style.transform = 'scale(' + scale + ')';
  }
}

const initSlickDots = () => {
  jQuery('.block-slider-gallery .component-slider').on('init reInit afterChange', resizeDots);
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
    initSlickDots();
	},
	loaded() {
    initSlickDots();
  },
	resized() {
	},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
